// Auto-generated by javascript_version.py
export const DATETIME_STR = "2024-08-07 11:32:47";
export const VERSION_DATETIME = new Date(DATETIME_STR);

const VERSION = { DATETIME_STR, VERSION_DATETIME };
export default VERSION;
